<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">
    <div class="l-row">
      <form-group v-if="Object.keys(variation.attributes).indexOf('color') !== -1" :label="$t(`color.label`)" :columns="3" :error="getError('attributes.color', variation.sku)">
        <input class="form-input" type="text" v-model="variation.attributes['color']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('size') !== -1" :label="$t(`size.label`)" :columns="3" :error="getError('attributes.size', variation.sku)">
        <input class="form-input" type="text" v-model="variation.attributes['size']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('voltage') !== -1" :label="$t(`voltage.label`)" :required="true" :columns="3" :error="getError('attributes.voltage', variation.sku)">
        <select class="form-select" v-model="variation.attributes['voltage']" :disabled="disabledInputs()">
          <option value="110V">110V</option>
          <option value="127V">127V</option>
          <option value="220V">220V</option>
          <option value="380V">380V</option>
          <option value="bivolt">bivolt</option>
        </select>
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    async mounted () {},
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?3f782e72